import "../css/gallery.css";
import { useState, useRef } from "react";

function Gallery({ gallery }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);

  const scrollToImage = (index) => {
    const element = scrollRef.current;
    if (element) {
      const scrollAmount = index * element.offsetWidth;
      element.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
      setCurrentIndex(index);
    }
  };

  const handleRight = () => {
    const newIndex = Math.min(currentIndex + 1, gallery.length - 1);
    scrollToImage(newIndex);
  };

  const handleLeft = () => {
    const newIndex = Math.max(currentIndex - 1, 0);
    scrollToImage(newIndex);
  };

  return (
    <div className="gallery-container">
      <div className="wrapper-gallery">
        <div id="wrappergallery" ref={scrollRef}>
          {gallery.map((item, index) => (
            <div className="item-gallery" key={index}>
              <img src={item.url} alt={item.title} />
           
            </div>
          ))}
        </div>
      </div>

      <div className="gallery-controls">
        <button
          className="nav-btn"
          onClick={handleLeft}
          disabled={currentIndex === 0}
        >
          <span className="material-icons">arrow_back_ios</span>
        </button>

        <div className="gallery-indicators">
          {gallery.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? "active" : ""}`}
              onClick={() => scrollToImage(index)}
            />
          ))}
        </div>

        <button
          className="nav-btn"
          onClick={handleRight}
          disabled={currentIndex === gallery.length - 1}
        >
          <span className="material-icons">arrow_forward_ios</span>
        </button>
      </div>
    </div>
  );
}

export default Gallery;
